import {twJoin} from "tailwind-merge";
import {CtaButtonEmpty} from "~/components/ctaButtonEmpty";
import {useFrontendProxyUrl} from "~/root/rootLoaderData";

/* Direct port of growthjockey--website/app/components/molecules/leadGenBlock.tsx */
export function LeadGenBlock({className}: {className?: string}) {
    const continueToIntellsysUrl = useFrontendProxyUrl("/u");

    return (
        <div
            className={twJoin(
                "w-full h-full md:h-[300px] py-lg relative bg-[linear-gradient(to_right,#1F40CB,#0F2065,#162E92)]",
                className,
            )}
        >
            <div className="relative h-full grid grid-cols-1 md:grid-cols-[1fr_auto] items-center gap-lg">
                <h2 className="relative text-heading3-5 text-[#ffffff] text-left md:text-left py-sm">
                    Ready to run your venture <br /> on one operating system?
                </h2>
                <div className="grid justify-end">
                    <CtaButtonEmpty
                        text="Continue to Intellsys"
                        href={continueToIntellsysUrl}
                        arrow={true}
                        className="shadow-[0_4px_4px_0_rgba(0,0,0,0.12)] ml-auto"
                    />
                </div>
            </div>
        </div>
    );
}
